import { Location } from 'vue-router'
import { NavigationGuard } from 'vue-router/types/router'

import { AnyValue } from "../../../../shared/types/AnyValue";
import { VueComponent } from "../../../../shared/types/VueComponent";
import { Layout } from '../../includes/types/Config'
import TemplateContext from '../TemplateContext'

export enum MenuItemType {
  DropDownLinkComponent = 'DropDownLinkComponent',
  DropDownLink = 'DropDownLink',
  DynamicHeader = 'DynamicHeader',
  Route = 'Route',
  DropDown = 'DropDown',
  Button = 'Button',
  Component = 'Component',
  Divider = 'Divider'
}

type ButtonType = 'danger' | 'primary' | 'dashed' | 'link'

type ButtonSize = 'large' | 'default' | 'small'

export type BreadcrumbMeta = { meta:{ title: string, active: boolean, url?: Location }}

export type Config = {
  name: string
  path: string
  query?: any
  component: VueComponent
  meta?: Record<string, any> | Record<string, (ctx: TemplateContext) => BreadcrumbMeta> | { requiresAuth?: boolean, disableLoader?:boolean, breadcrumbs?: (ctx: TemplateContext) => Array<BreadcrumbStruct> }
  params?: AnyValue<Record<string, any>, TemplateContext | null>
  beforeEnter?: NavigationGuard
}

export type MenuItemRoute = {
  layout: Layout.Panel | Layout.Fullscreen
  config: Config
}

export type MultipleComponentsConfig = Omit<Config, 'component'> & {
  components?: {
    default: () => any
    sidebarContent: () => any
  }
  component?: VueComponent
}

export type MenuItemRouteWithPanel = {
  layout: Layout.SidebarPanel
  config: MultipleComponentsConfig
}

export type BreadcrumbStruct = {
  label?: AnyValue<string, TemplateContext | null>,
  image?: AnyValue<string, TemplateContext | null>,
  routeName?: string,
  iconName?: string,
  isVisible?: Array<AnyValue<boolean, TemplateContext | null>>
  children?: Array<BreadcrumbStruct>
}

export type RouteConfig = {
  routeConfig: MenuItemRoute | MenuItemRouteWithPanel
}

export type MenuItemTags = {
  tag?: (() => string)
  tagColor?: (() => string)
}

export type BaseMenuItem = {
  isVisible: Array<AnyValue<boolean, TemplateContext | null>>
  featherIcon?: boolean
  icon?: string
  class?: Array<AnyValue<string, TemplateContext | null>> | string
}

export type MenuItemWithRouteConfig = BaseMenuItem & RouteConfig & MenuItemTags

export type MenuItemWithoutRouteConfig = Omit<MenuItemWithRouteConfig, 'routeConfig'>

export type CustomComponent = {
  type: MenuItemType.Component
  component: VueComponent
  name?: string
} & BaseMenuItem

export type Route = {
  type: MenuItemType.Route
  iconPosition?: 'left' | 'right'
} & MenuItemWithRouteConfig

export type DynamicHeader = {
  type: MenuItemType.DynamicHeader
  header: AnyValue<string, TemplateContext | null>
  avatar?:AnyValue<string, TemplateContext | null>
  to?: Location
} & MenuItemWithoutRouteConfig

export type DropDownLink = {
  name: string
  type: MenuItemType.DropDownLink
  url: AnyValue<string, TemplateContext | null>
} & MenuItemWithoutRouteConfig

export type DropDownComponent = {
  type: MenuItemType.DropDownLinkComponent
  name: string
  component: VueComponent | undefined
} & MenuItemWithoutRouteConfig

export type Button = {
  name: string
  type: MenuItemType.Button
  to?: string | Location
  href?: AnyValue<string, TemplateContext | null>
  buttonType?: ButtonType
  class?: Array<AnyValue<string, TemplateContext>> | string
  size?: ButtonSize,
  onClick?(): void
} & MenuItemWithoutRouteConfig

export type MenuDivider = Partial<Pick<BaseMenuItem, 'isVisible'>> & {
  type: MenuItemType.Divider
}

export type DropDown = {
  name: string
  guid: string
  submenu: Array<Record<'menuItem', Route | DynamicHeader | DropDown | DropDownLink | DropDownComponent | Button>>
  type: MenuItemType.DropDown
  selected?: Array<AnyValue<boolean, TemplateContext | null>>
} & MenuItemWithoutRouteConfig

export type ConfigMenuItem = Route | DynamicHeader | DropDown | DropDownLink | DropDownComponent | Button | CustomComponent | MenuDivider

// export type MenuItem = Omit<ConfigMenuItem, 'isVisible'>
//
// export type TemplateRoute = {
//   slug: string
//   url: string
//   name: string
// } & Omit<Route, 'routeConfig' | 'isVisible'>
//
// // eslint-disable-next-line no-use-before-define
// export type TemplateType = Omit<TemplateDropDown, 'isVisible'> | TemplateRoute | Omit<DropDownLink, 'isVisible'> | Omit<DropDownComponent, 'isVisible'>
//
// export type TemplateDropDown = {
//   guid: string
//   name: string
//   submenu: Array<TemplateType>
//   type: MenuItemType.DropDown
// } & MenuItemWithoutRouteConfig
